import styled from 'styled-components';

export const ContainerSwitch = styled.div`
  margin: 0px 3px;
`;
